var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "admin-row-actions admin-row-actions--inline",
      attrs: { role: "group", "aria-label": _vm.trans("general.actions") },
      on: {
        mouseover: _vm.onHover,
        focusin: _vm.onHover,
        mouseout: _vm.onLeave,
        focusout: _vm.onLeave,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }